// Share-card affordances (§5.5). A "share this" button on the disputes section
// (dispute card) and a score card share on the header. Renders on a canvas and
// delivers via native share sheet (mobile) or download (desktop).

import { useState } from "react";
import {
  renderScoreCard,
  renderDisputeCard,
  deliverCard,
  type ScoreCardData,
  type DisputeCardData,
} from "../lib/shareCard.ts";

export function ShareScoreButton({ data }: { data: ScoreCardData }) {
  const [busy, setBusy] = useState(false);
  return (
    <button
      type="button"
      data-testid="action-share-score"
      className="inline-flex min-h-[40px] items-center gap-2 rounded-pill border border-paper-50/30 px-4 py-2 text-sm font-semibold text-paper-50 transition-colors hover:bg-paper-50/10"
      disabled={busy}
      onClick={async () => {
        setBusy(true);
        try {
          await deliverCard(renderScoreCard(data), `twoshot-${data.nameA}-${data.nameB}.png`);
        } finally {
          setBusy(false);
        }
      }}
    >
      {busy ? "Rendering…" : "Share score card"}
    </button>
  );
}

export function ShareDisputeButton({ data }: { data: DisputeCardData }) {
  const [busy, setBusy] = useState(false);
  return (
    <button
      type="button"
      data-testid="action-share-dispute"
      className="text-sm text-ink-400 underline"
      disabled={busy}
      onClick={async () => {
        setBusy(true);
        try {
          await deliverCard(renderDisputeCard(data), `twoshot-dispute-${data.title}.png`);
        } finally {
          setBusy(false);
        }
      }}
    >
      {busy ? "Rendering…" : "Share this dispute"}
    </button>
  );
}
